import React, { useEffect, useState } from "react";
import AdvancedDataTable from "../../components/AdvancedDataTable";
import axios from "../../api/axios";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";

const CropsList = () => {
  const [crops, setCrops] = useState([]);
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

  useEffect(() => {
    axios
      .get("/api/v1/crops")
      .then((res) => setCrops(res.data))
      .catch((err) => console.error(err));
  }, []);

  const handleFormSubmit = async (data) => {
    try {
      if (data.id && onRowEdit) {
        const updated = await onRowEdit(data);
        if (!updated || !updated.id) throw new Error("Invalid updated data");

        setRowData((prevRows) =>
          prevRows.map((row) => (row.id === updated.id ? updated : row))
        );
        showSnackbar("Record updated successfully", "success");
      } else if (onAdd) {
        const newData = await onAdd(data);
        if (!newData || !newData.id) {
          console.error("newData is invalid:", newData);
          throw new Error("Failed to get created data from server.");
        }

        setRowData((prevRows) => [newData, ...prevRows]);
        showSnackbar("Record added successfully", "success");
      } else {
        console.log("Form submitted:", data);
      }
    } catch (error) {
      console.error("Form submission error:", error);
      showSnackbar("Failed to save data", "error");
    } finally {
      setFormDialogOpen(false);
    }
  };

  const handleDeleteClick = (row) => {
    setRowToDelete(row);
    setConfirmOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axios.delete(`/api/v1/crops/${rowToDelete.id}/`);
      setRowData((prev) => prev.filter((r) => r.id !== rowToDelete.id));
      showSnackbar("Record deleted successfully", "success");
    } catch (err) {
      console.error(err);
      showSnackbar("Failed to delete record", "error");
    } finally {
      setConfirmOpen(false);
      setRowToDelete(null);
    }
  };

  const onAdd = async (data) => {
    try {
      const response = await axios.post("/api/v1/crops/", data);
      return response.data;
    } catch (error) {
      console.error("onAdd error:", error);
      throw error;
    }
  };

  const onRowEdit = async (data) => {
    try {
      const response = await axios.put(`/api/v1/crops/${data.id}/`, data);
      return response.data;
    } catch (error) {
      console.error("Edit error:", error);
      throw error;
    }
  };

  const handleRefresh = async () => {
    try {
      const response = await axios.get("/api/v1/crops/");
      setRowData(response.data);
      showSnackbar("Data refreshed successfully", "success");
    } catch (error) {
      setSnackbarMessage("Failed to refresh data.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleImport = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    axios
      .post("/api/v1/crops/import", formData)
      .then((res) => setCrops(res.data))
      .catch((err) => console.error("Import failed:", err));
  };

  const handleDelete = (row) => {
    if (window.confirm(`Delete role ${row.name}?`)) {
      axios
        .delete(`/api/v1/crops/${row.id}`)
        .then(() => setCrops((prev) => prev.filter((r) => r.id !== row.id)))
        .catch((err) => console.error(err));
    }
  };

  const columns = [
    {
      field: "crop",
      headerName: "Crop",
      flex: 1,
      renderCell: (params) => (
        <Link
          to={`/crops/${params.row.id}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <img
              src={`${baseUrl}/${params.row.image}`}
              alt={params.row.name}
              style={{ width: 40, height: 40, borderRadius: "50%" }}
            />
            <span>{params.row.name}</span>
          </Box>
        </Link>
      ),
    },

    { field: "description", headerName: "Description", flex: 1.5 },
  ];

  return (
    <>
      <AdvancedDataTable
        rows={crops}
        columns={columns}
        exportFileName="crops"
        onImport={handleImport}
        onRowDelete={handleDelete}
      />

      <FormDialog
        open={formDialogOpen}
        onClose={() => setFormDialogOpen(false)}
        onSubmit={handleFormSubmit}
        initialData={formInitialData}
      />
    </>
  );
};

export default CropsList;
